import { influencerStories } from '@/mocks/influencer';
import type { InfluencerItem } from '@/pages/home/types';

const items: InfluencerItem[] = influencerStories;

export default function Influencer() {
  return (
    <section id="influencer" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20 bg-background-50">
      <div className="mb-8 md:mb-12 max-w-2xl">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold text-primary-600 bg-primary-100 px-3 py-1.5 rounded-full mb-4">
          <i className="ri-live-line"></i> 网红黑料
        </span>
        <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug mb-3">
          直播争议与内容原创性讨论
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
          每一条都尽量保留多方说法，把争议点、回应与后续进展列清楚，方便你判断信息是否站得住脚。
        </p>
      </div>

      <div className="flex flex-col gap-10 md:gap-14">
        {items.map((item, index) => (
          <div key={item.id} className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 items-center">
            <div className={`relative w-full h-[260px] md:h-[360px] rounded-lg overflow-hidden ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
              <img
                src={item.image}
                alt={item.title}
                title={`${item.name} · ${item.title} · 爆料网`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-3 left-3 flex flex-wrap gap-2">
                <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-bold">
                  {item.status}
                </span>
                <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-bold">
                  <i className="ri-fire-line mr-1 text-primary-500"></i>
                  {item.heat}
                </span>
              </div>
            </div>

            <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
              <div className="flex items-center gap-3 mb-4">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800 font-heading font-black">
                  {item.name.slice(0, 1)}
                </span>
                <div>
                  <div className="font-heading font-bold text-foreground-950">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.handle}</div>
                </div>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-black text-foreground-950 leading-snug mb-3">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">{item.detail}</p>
              <ul className="space-y-2.5">
                {item.points.map((point, i) => (
                  <li key={point} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span
                      className={`flex-shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center rounded-md text-xs ${
                        i % 2 === 0 ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-800'
                      }`}
                    >
                      <i className="ri-check-line"></i>
                    </span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 md:mt-12 flex items-start gap-3 p-4 md:p-5 rounded-lg bg-secondary-50 border border-secondary-200">
        <span className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 dark:text-foreground-950">
          <i className="ri-information-line"></i>
        </span>
        <p className="text-sm text-foreground-700 leading-relaxed">
          提醒：以上内容为公开信息整理与讨论汇总，不代表本站立场。涉及具体当事人时，请以官方说明和平台规则为准，理性吃瓜。
        </p>
      </div>
    </section>
  );
}